import type { AuthChangeEvent } from "@supabase/supabase-js";

export type AuthBoundaryEventAction =
  | "resolve-initial"
  | "resolve-if-new-user"
  | "reload-profile"
  | "sign-out"
  | "ignore";

/**
 * Auth events are broadcast between same-origin Supabase clients, including the
 * editor and its embedded player preview. Token refreshes do not change the
 * current user's profile access and must not trigger another identity request.
 */
export function authBoundaryEventAction(event: AuthChangeEvent): AuthBoundaryEventAction {
  switch (event) {
    case "INITIAL_SESSION":
      return "resolve-initial";
    case "SIGNED_IN":
    case "PASSWORD_RECOVERY":
    case "MFA_CHALLENGE_VERIFIED":
      return "resolve-if-new-user";
    case "USER_UPDATED":
      return "reload-profile";
    case "SIGNED_OUT":
      return "sign-out";
    case "TOKEN_REFRESHED":
      return "ignore";
  }
}
